import type { Theme } from "../tokens";

/** A VT220 that learned manners. One type size; hierarchy from weight alone. */
export const amber: Theme = {
  id: "amber",
  name: "Amber",
  thesis: "A VT220 that learned manners. One type size; hierarchy from weight alone.",
  scheme: "dark",
  colors: {
    ground: "#080806",
    surface: "#100F0B",
    raised: "#181509",
    ink: "#FFB000",
    dim: "#B87A00",
    rule: "#2A1F00",
    lattice: "#1E1700",
    focus: "#FFB000",
    inbox: "#FFB000",
    feed: "#B87A00",
    paperTrail: "#A06E00",
    screener: "#FF4D3D",
  },
  type: {
    sans: "'IBM Plex Mono', ui-monospace, monospace",
    mono: "'IBM Plex Mono', ui-monospace, monospace",
    googleFonts: "IBM+Plex+Mono:wght@400;600",
    tracking: "0",
  },
  density: {
    row: 26,
    primary: 14,
    secondary: 14,
    meta: 14,
    listWidth: 760,
    rail: 200,
    radius: 0,
    lineHeight: 1.3,
  },
  markers: {
    inbox: ">",
    feed: "-",
    paperTrail: ".",
    screener: "!",
  },
};
